export default "<aside>\n  <nav>\n    <div ng-transclude></div>\n  </nav>\n</aside>\n";